export default '.doc, .docx, .pdf, .txt, .csv, .xls, .xlsx, .ppt, .pptx, .odp, .key, .rtf, .html, ' +
  '.jpeg, .jpg, .gif, .svg, .png, .tiff,  .tif, .heic, .heif, ' +
  '.mp4, .avi, .mov, .flv, ' +
  '.mp3,  .wav, .m4a, ' +
  '.rar, .zip';
